export default function isBrowser() {
  return typeof document !== "undefined";
}
